export const ACTIVITY_SAVE_STATE_UPDATE = "ACTIVITY_SAVE_STATE_UPDATE";
export const ACTIVITY_SAVE_ORDER = "ACTIVITY_SAVE_ORDER";
